// extracted by mini-css-extract-plugin
export default {"wrapper":"TabsContent_wrapper__pUR4m","info_container":"TabsContent_info_container__P4KmV","description":"TabsContent_description__vgtfi","price":"TabsContent_price__H--Hp"};